import { useNavigate } from "react-router-dom";
import { GatewayInfoSocieteOrias } from "@conformite/gateway";
import { ConformiteSocieteList } from "./ConformiteSocieteList";

export function ConformiteSocieteListDeclarationActiviteIobsp() {
  const navigate = useNavigate();

  return (
    <ConformiteSocieteList
      getFormAvancement={(entreprise) =>
        entreprise.avancement.declarationActiviteIobsp ?? 0
      }
      defaultFilters={{
        categories: GatewayInfoSocieteOrias.CategorieIOBSPList,
      }}
      title="Déclaration activité IOBSP"
      onSocieteRedirect={(entreprise) => {
        navigate(`${entreprise.siren}?fromAxe`);
      }}
      getIsOptional={(entreprise) =>
        entreprise.declarationActiviteIOBSPOptionnelle
      }
    />
  );
}
